import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as briefActions from '@core/actions/brief.actions';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import * as FileSaver from 'file-saver/FileSaver';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class BriefService {
  constructor(private http: HttpClient, private store: Store<any>) {}

  getBriefs() {
    return this.http.get(`${API}briefs`);
  }

  getInfoModalBrief() {
    return this.http.get(`${API}briefs/info-modal`);
  }

  createBrief(data) {
    return this.http.post(`${API}briefs/`, data);
  }

  updateBrief(id, data) {
    return this.http.put(`${API}briefs/${id}`, data);
  }

  changeStatus(id, data) {
    console.log("ID ->", id)
    return this.http.put(`${API}briefs/change-status/${id}`, data);
  }

  exportBrief(id, fileName) {
    return this.http.get(`${API}briefs/export/${id}`,{
      responseType: 'blob',
      observe: 'response'
    }).subscribe(
      response => {
        const blob = response.body;
        FileSaver.saveAs(blob, `Brief - ${fileName}`);
        this.store.dispatch(new briefActions.ExportBriefSuccess());
      },
      err => {
        this.store.dispatch(new briefActions.ExportBriefFail(err));
      }
    );
  }

  downloadBriefFinal(id, fileName) {
    return this.http.get(`${API}briefs/download-brief-final/${id}`).subscribe(
      response => {
        this.downloadTemplate({downloadUrl: response, name: fileName, isInitial: false})
      },
      err => {
        this.store.dispatch(new briefActions.DownloadBriefPMFail(err));
      }
    );
  }

  downloadBriefPM(id, fileName) {
    return this.http.get(`${API}briefs/download-brief-pm/${id}`).subscribe(
      response => {
        this.downloadTemplate({downloadUrl: response, name: fileName, isInitial: true})
      },
      err => {
        this.store.dispatch(new briefActions.DownloadBriefPMFail(err));
      }
    );
  }

  downloadTemplate(data) {
    const { name, downloadUrl, isInitial } = data;
    console.log("LLEGA A DESCARGA TEMPLATE", downloadUrl)
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          if (isInitial) {
            FileSaver.saveAs(blob, `Brief inicial - ${name}.xlsx`);
          } else {
            FileSaver.saveAs(blob, `Brief final - ${name}.xlsx`);
          }
          // this.store.dispatch(new FileActions.ExportFollowSuccess());
        },
        err => {
          this.store.dispatch(new briefActions.DownloadBriefPMFail(err));
        }
      );
  }

  exportInitialBrief() {
    return this.http.get(`${API}briefs/export-initial`,{
      responseType: 'blob',
      observe: 'response'
    }).subscribe(
      response => {
        const blob = response.body;
        FileSaver.saveAs(blob, `Brief inicial`);
        this.store.dispatch(new briefActions.ExportBriefSuccess());
      },
      err => {
        this.store.dispatch(new briefActions.ExportBriefFail(err));
      }
    );;
  }
}
